import React from 'react';
import { Helmet } from 'react-helmet-async';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const BaseMeta = _ref => {
  let {
    title,
    canonicalUrl,
    description
  } = _ref;
  return /*#__PURE__*/_jsxs(Helmet, {
    prioritizeSeoTags: true,
    children: [title ? /*#__PURE__*/_jsx("title", {
      children: title
    }) : null, canonicalUrl ? /*#__PURE__*/_jsx("link", {
      rel: "canonical",
      href: canonicalUrl
    }) : null, description ? /*#__PURE__*/_jsx("meta", {
      name: "description",
      content: description
    }) : null]
  });
};
export default BaseMeta;